<template>
  <component
    class="dropdown"
    :is="tag"
    :class="[
      { show: isOpen },
      { dropdown: direction === 'down' },
      { dropup: direction === 'up' }
    ]"
    aria-haspopup="true"
    :aria-expanded="isOpen"
    @click="toggleDropDown"
    v-click-outside="closeDropDown"
  >
    <slot name="title">
      <a
        class="dropdown-toggle nav-link"
        :class="{ 'no-caret': hideArrow }"
        data-toggle="dropdown"
      >
        <div class="logo-container">
          <span class="icon" :class="icon"></span>
        </div>
        <span class="no-icon ml-2">{{ title }}</span>
      </a>
    </slot>
    <ul
      class="dropdown-menu"
      :class="[
        { 'dropdown-menu-right': position === 'right' },
        { show: isOpen }
      ]"
    >
      <slot></slot>
    </ul>
  </component>
</template>
<script>
export default {
  name: 'drop-down',
  props: {
    direction: {
      type: String,
      default: 'down'
    },
    title: String,
    icon: String,
    position: String,
    hideArrow: Boolean,
    tag: {
      type: String,
      default: 'li'
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  provide() {
    return {
      closeDropDown: this.closeDropDown
    }
  },
  methods: {
    toggleDropDown() {
      this.isOpen = !this.isOpen;
      this.$emit('change', this.isOpen);
    },
    closeDropDown() {
      this.isOpen = false;
      this.$emit('change', this.isOpen);
    }
  }
};
</script>
<style scoped>
.dropdown {
  list-style-type: none;

  a {
    display: flex;
    flex-direction: row;
    align-items: center;
    .icon {
      font-size: 20px;
      line-height: 20px;
    }
  }
}

.logo-container {
  height: 22px !important;
  width: 22px !important;
  display: flex;
  align-items: center;
  justify-content: center;

  .mdi {
    height: 100%;
    width: 100%;

    font-size: 20px;
    line-height: 20px;
  }
}

.dropdown .dropdown-toggle {
  cursor: pointer;
}
</style>
